module.exports = __webpack_public_path__ + "378f2018d299425332b3240cc0c731c4.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/proxima-nova/2E6388_1_0.ttf
// module id = 533
// module chunks = 0